export const IsProductPage = window.location.href.includes('-_-');
